import { defineComponent as _defineComponent } from 'vue';
import { computed, nextTick, ref } from 'vue';
import { bannerVariants } from './bannerVariants';
import EnButton from 'Components/base/EnButton';
import { AlertCircle, Info, CheckCircle, AlertTriangle, XCircle, X as XIcon } from 'lucide-vue-next';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnBanner',
    props: {
        variant: { type: String, required: false, default: 'default' },
        title: { type: String, required: false, default: '' },
        closable: { type: Boolean, required: false, default: false },
        icon: { type: null, required: false, default: undefined }
    },
    emits: ['close'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const variantIcons = {
            default: AlertCircle,
            info: Info,
            success: CheckCircle,
            warning: AlertTriangle,
            error: XCircle,
            transparent: AlertCircle,
        };
        /*
         * Determines which icon to show.
         * If icon is null, we show nothing at all.
         * If a custom icon component was passed, we use that.
         * Otherwise we fall back to the default icon for the current variant.
         */
        const resolvedIcon = computed(() => {
            if (props.icon === null)
                return null;
            return props.icon ?? variantIcons[props.variant];
        });
        const bannerClass = computed(() => bannerVariants({ variant: props.variant }));
        const onClose = () => emit('close');
        const elementRoot = ref();
        async function scrollToMe() {
            await nextTick();
            elementRoot.value?.scrollIntoView({ behavior: 'smooth' });
        }
        __expose({
            scrollToMe
        });
        const __returned__ = { props, emit, variantIcons, resolvedIcon, bannerClass, onClose, elementRoot, scrollToMe, get EnButton() { return EnButton; }, get XIcon() { return XIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
